export const ACTION_TYPES = {
  GET_CONF: 'global/GET_CONF',
  GET_AVATAR: 'global/GET_AVATAR',
  GET_AVATAR_LIST: 'global/GET_AVATAR_LIST',
  GET_SELLING_POINTS: 'gloabal/GET_SELLING_POINTS',
  GET_FOOTER_CONF: 'global/GET_FOOTER_CONF',
  SET_DEVICE_TYPE:'global/SET_DEVICE_TYPE'
};
